import { enableES5, produce } from "immer";
import { defaults } from "react-sweet-state";
// immer hack, immerable cannot be compiled from esm.js
var hasSymbol = typeof Symbol !== "undefined";
var immerable = hasSymbol
    ? Symbol("immer-draftable")
    : "__$immer_draftable";
enableES5(); // for IE11
defaults.mutator =
    function (currentState, producer) { return produce(currentState, producer); };
defaults.devtools =
    true;
function storeAction(modifier) {
    return function (store) {
        store.setState(function (state) { return modifier(state); });
    };
}
export { storeAction };
